import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import ListGroupItem from 'react-bootstrap/ListGroupItem';
import Image from "react-bootstrap/Image";
import Badge from "react-bootstrap/Badge";
import { useEffect } from 'react';

import StFooter from "../components/StFooter";
import StNavbar from "../components/StNavbar";
import { SetSeo } from '../lib/common_funcs';

import '../redesign-2025.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import {BlogsConfig} from "./Blogs/BlogsConfig";


const StBlogHome = () => {

    useEffect(() => {
        AOS.init({
            duration: 800,
            once: true,
            easing: 'ease-out-cubic',
            offset: 50
        });
    }, []);
                       

    const allTemplatePageSeo = {
        "title": "TurboSteed Blog: Web Hosting, Design & Development Tips",
        "description": "Read the latest articles and tutorials on web hosting best practices, site design trends, coding tips, and getting the most out of TurboSteed's platform.",
        "canonicalUrl": "https://turbosteed.com/blogs",
        "keywords": "web hosting blog, development tutorials, website design tips, TurboSteed news",
        "ogType": "website",
        "ogTitle": "The Official TurboSteed Blog",
        "ogDescription": "Articles and guides for both developers and creators. Stay informed on web speed and SEO!",
        "ogImage": "https://turbosteed.com/images/social/share-blog-index.jpg",
        "twitterCard": "summary_large_image",
        "robots": "index, follow",
		// All other values will be default
	}
	
	const schemaMarkup = {
        "@context": "https://schema.org",
        "@type": "Blog",
        "name": "TurboSteed Blog",
        "url": "https://turbosteed.com/blogs"
    }

    const allParams = {
		"seo": allTemplatePageSeo,
		"schema": schemaMarkup
	}

    return (
        <div className="ts-redesign">
            {/* Call the Seo component at the top of the page component */}
            <SetSeo {...allParams} />

            <StNavbar />

            <header className="ts-page-hero">
                <div className="ts-hero-bg">
                    <div className="ts-gradient-orb ts-orb-1"></div>
                    <div className="ts-gradient-orb ts-orb-2"></div>
                </div>
                <div className="container">
                    <h1 className="ts-page-title" data-aos="fade-up">TurboSteed Blog</h1>
                    <p className="ts-page-subtitle" data-aos="fade-up" data-aos-delay="100">Tips, tutorials, and insights for web creators</p>
                </div>
            </header>

            <main className="main-content">
                <section className="ts-section ts-section-light">
                    <div className="container">
                        <div className="ts-blog-grid">
                            {BlogsConfig.blogList.map((blogDetail, index) => (
                                <div key={blogDetail.blogUrl} className="ts-blog-card" data-aos="fade-up" data-aos-delay={index * 100}>
                                    <span className="ts-blog-category">{blogDetail.blogType}</span>
                                    <h2 className="ts-blog-title">{blogDetail.blogTitle}</h2>
                                    <p className="ts-blog-desc">{blogDetail.blogDesc}</p>
                                    <a className="ts-btn ts-btn-primary" href={blogDetail.blogUrl}>
                                        Read Article
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M5 12h14M12 5l7 7-7 7"/>
                                        </svg>
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </main>        

{/*}
            <div className='mt-0 mb-5 gradient-new-theme jumbotron-blog'>
                <Container className='flex-lg-row align-items-center'>
                    <Row className=''>
                        <Col className="jumbotron-text">
                            <div className="h1 mx-5">TurboSteed Blog</div>
                            <div className="h2 mx-5">Your go-to resource for insights and tips on hosting</div>
                           
                        </Col>
                    
                    </Row>
                </Container>
            </div>
            */}
                        

            {/*      
            <Container className="d-flex flex-wrap my-5 ">

                {BlogsConfig.blogList.map((blogDetail) => (
                    <Card key={Math.random()} style={{width: "20rem"}} className="mx-auto">
                            
                        <Container className="d-flex flex-row my-2">
                            <Badge className="my-2 mx-1" bg="primary">{blogDetail.blogType}</Badge>
                        </Container>

                        <Card.Body className="d-flex flex-column mt-auto">
                            <Card.Title><p className="h2">{blogDetail.blogTitle}</p></Card.Title>
                            <Card.Text className="my-4">
                                <span className="h6">{blogDetail.blogDesc}</span>
                            </Card.Text>
                            <Card.Footer className="mt-auto p-0 border-0 bg-white">
                                <Button className="mt-auto" href={blogDetail.blogUrl}>Learn more</Button>
                            </Card.Footer>
                        </Card.Body>
								
                    </Card>            
                ))}
            
            </Container>
            */}

            <StFooter />
        </div>

    );

}

export default StBlogHome;
